import axios from 'axios';
axios.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Automatically switch between local and production servers
const BASE_URL = process.env.NODE_ENV === 'production'
    ? "https://park-easy-server.onrender.com"
    : "http://localhost:5000";

export const fetchParkings = async ({ user_id, country, city, address, setParkings }) => {
    try {
        let query = '';
        if (user_id) {
            query += `?user_id=${user_id}&`
        }
        else {
            query += '?'
        }
        if (country) {
            query += `country=${country}&`
        }
        if (city) {
            query += `city=${city}&`
        }
        if (address) {
            query += `address=${address}`
        }
        const result = await axios.get(`${BASE_URL}/parking${query}`)
        console.log('fetchParkings ', result);
        setParkings(result?.data || [])

    } catch (error) {
        console.error('fetchParkings ', error);
    }
}

export const login = async ({ email, password, handleLoginSuccess, handleLoginFailure }) => {
    try {
        const result = await axios.post(`${BASE_URL}/user/login`, { email, password })
        if (result?.data?.token) {
            return handleLoginSuccess(result.data)
        }
        console.log('login ', result);
    } catch (error) {
        console.error('login ', error);
        handleLoginFailure(error?.response?.data?.error)
    }
}

export const register = async ({ name, email, phone, password, type, handleRegisterSuccess, handleRegisterFailure }) => {
    try {
        const result = await axios.post(`${BASE_URL}/user/register`, {
            name,
            email,
            phone,
            password,
            type
        })
        if (result?.data?._id || result?.data?.name) {
            return handleRegisterSuccess()
        }
        console.log('register ', result);
        handleRegisterFailure('Registration failed')
    } catch (error) {
        console.error('register ', error);
        handleRegisterFailure(error?.response?.data?.error)
    }
}

export const createParking = async ({ body, handleCreateParkingSuccess, handleCreateParkingFailure }) => {
    try {
        const result = await axios.post(`${BASE_URL}/parking`, { ...body })
        console.log('createParking ', result);
        if (result?.data?.parking) {
            return handleCreateParkingSuccess(result.data)
        }

    } catch (error) {
        console.error('createParking ', error);
        handleCreateParkingFailure(error?.response?.data?.error)
    }
}

export const updateParking = async ({ id, body, handleUpdateParkingSuccess, handleUpdateParkingFailure }) => {
    try {
        const result = await axios.put(`${BASE_URL}/parking/${id}`, { ...body })
        if (result?.data?.message) {
            return handleUpdateParkingSuccess(result.data)
        }
        console.log('updateParking ', result);
    } catch (error) {
        console.error('updateParking ', error);
        handleUpdateParkingFailure(error?.response?.data?.error)
    }
}

export const fetchSpaces = async ({ user_id, parking_id, name, date, time, availability, setSpaces }) => {
    try {
        const params = new URLSearchParams();
        if (user_id) {
            params.append('user_id', user_id)
        }
        if (parking_id) {
            params.append('parking_id', parking_id)
        }
        if (name) {
            params.append('name', name)
        }
        if (date) {
            params.append('date', date)
        }
        if (time) {
            params.append('time', time)
        }
        if (availability === true) {
            params.append('availability', 'true')
        }

        const query = params.toString();
        const result = await axios.get(`${BASE_URL}/space${query ? `?${query}` : ''}`)
        console.log('fetchSpaces ', result);
        setSpaces(result?.data || [])
    } catch (error) {
        console.error('fetchSpaces ', error);
    }
}

export const createSpace = async ({ body, handleCreateSpaceSuccess, handleCreateSpaceFailure }) => {
    try {
        const result = await axios.post(`${BASE_URL}/space`, { ...body })
        if (result?.data?.space) {
            return handleCreateSpaceSuccess(result.data)
        }
        console.log('createSpace ', result);
    } catch (error) {
        console.error('createSpace ', error);
        handleCreateSpaceFailure(error?.response?.data?.error)
    }
}

export const updateSpace = async ({ id, body, handleUpdateSpaceSuccess, handleUpdateSpaceFailure }) => {
    try {
        const result = await axios.put(`${BASE_URL}/space/${id}`, { ...body })
        if (result?.data?.message) {
            return handleUpdateSpaceSuccess(result.data)
        }
        console.log('updateSpace ', result);
    } catch (error) {
        console.error('updateSpace ', error);
        handleUpdateSpaceFailure(error?.response?.data?.error)
    }
}

export const fetchBookings = async ({ owner_id, user_id, setBookings }) => {
    try {
        const token = localStorage.getItem("token");

        const params = new URLSearchParams();
        if (user_id) params.append('user_id', user_id);
        if (owner_id) params.append('owner_id', owner_id);

        const result = await axios.get(
            `${BASE_URL}/booking?${params.toString()}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );

        setBookings(result?.data || []);
    } catch (error) {
        console.error('fetchBookings ', error);
    }
}


export const createBooking = async ({ body, handleCreateBookingSuccess, handleCreateBookingFailure }) => {
    try {
        const result = await axios.post(`${BASE_URL}/booking`, { ...body })
        console.log('createBooking ', result?.data);
        if (result?.data?.booking) {
            return handleCreateBookingSuccess(result.data)
        }
    } catch (error) {
        console.error('createBooking ', error);
        handleCreateBookingFailure(error?.response?.data?.error)
    }
}

export const resetPassword = async ({ user_id, body, handleResetPasswordSuccess, handleResetPasswordFailure }) => {
    try {
        console.log('body ', body);
        const result = await axios.post(`${BASE_URL}/user/resetPassword/${user_id}`, { ...body })
        console.log('resetPassword ', result?.data);
        if (result?.data?.user) {
            return handleResetPasswordSuccess(result.data)
        }
    } catch (error) {
        console.error('resetPassword ', error);
        handleResetPasswordFailure(error?.response?.data?.error)
    }
}

export const updateUser = async ({ user_id, body, handleUpdateUserSuccess, handleUpdateUserFailure }) => {
    try {
        console.log('body ', body);
        const result = await axios.put(`${BASE_URL}/user/${user_id}`, { ...body })
        console.log('updateUser ', result?.data);
        if (result?.data?.user) {
            return handleUpdateUserSuccess(result.data)
        }
    } catch (error) {
        console.error('updateUser ', error);
        handleUpdateUserFailure(error?.response?.data?.error)
    }
}

export const deleteParking = async ({ id, handleDeleteParkingSuccess, handleDeleteParkingFailure }) => {
    try {
        const result = await axios.delete(`${BASE_URL}/parking/${id}`)
        if (result?.data?.message) {
            return handleDeleteParkingSuccess(result.message)
        }
        console.log('deleteParking ', result);
    } catch (error) {
        console.error('deleteParking ', error);
        handleDeleteParkingFailure(error?.response?.data?.error)
    }
}


export const deleteSpace = async ({ id, handleDeleteSpaceSuccess, handleDeleteSpaceFailure }) => {
    try {
        const result = await axios.delete(`${BASE_URL}/space/${id}`)
        if (result?.data?.message) {
            return handleDeleteSpaceSuccess(result.message)
        }
        console.log('deleteSpace ', result);
    } catch (error) {
        console.error('deleteSpace ', error);
        handleDeleteSpaceFailure(error?.response?.data?.error)
    }
}

export const deleteBooking = async ({ id, handleDeleteBookingSuccess, handleDeleteBookingFailure }) => {
    try {
        const result = await axios.delete(`${BASE_URL}/booking/${id}`)
        if (result?.data?.message) {
            return handleDeleteBookingSuccess(result.message)
        }
        console.log('deleteBooking ', result);
    } catch (error) {
        console.error('deleteBooking ', error);
        handleDeleteBookingFailure(error?.response?.data?.error)
    }
}

export const updateBooking = async ({ id, body, handleUpdateBookingSuccess, handleUpdateBookingFailure }) => {
    try {
        const result = await axios.put(`${BASE_URL}/booking/${id}`, { ...body })
        if (result?.data?.message) {
            return handleUpdateBookingSuccess(result.data?.message)
        }
    } catch (error) {
        console.error('updateBooking ', error);
        handleUpdateBookingFailure(error?.response?.data?.error)
    }
}

export const fetchReviews = async ({ owner_id, setReviews }) => {
    try {
        let query = '';
        if (owner_id) {
            query += `?owner_id=${owner_id}`
        }
        const result = await axios.get(`${BASE_URL}/review${query}`)
        console.log('fetchReviews ', result);
        setReviews(result?.data || [])
    } catch (error) {
        console.error('fetchReviews ', error);
    }
}

export const createReview = async ({ body, handleCreateReviewSuccess, handleCreateReviewFailure }) => {
    try {
        const result = await axios.post(`${BASE_URL}review`, { ...body })
        if (result?.data) {
            return handleCreateReviewSuccess(result.data)
        }
        console.log('createReview ', result);
    } catch (error) {
        console.error('createReview ', error);
        handleCreateReviewFailure(error?.response?.data?.error)
    }
}

export const deleteReview = async ({ id, handleDeleteReviewSuccess, handleDeleteReviewFailure }) => {
    try {
        const result = await axios.delete(`${BASE_URL}/review/${id}`)
        if (result?.data?.message) {
            return handleDeleteReviewSuccess(result.message)
        }
        console.log('deleteReview ', result);
    } catch (error) {
        console.error('deleteReview ', error);
        handleDeleteReviewFailure(error?.response?.data?.error)
    }
}

export const fetchUsers = async ({ setUsers }) => {
    try {
        const result = await axios.get(`${BASE_URL}/user`)
        console.log('fetchUsers ', result);
        setUsers(result?.data || [])
    } catch (error) {
        console.error('fetchUsers ', error);
    }
}

export const deleteUser = async ({ id, handleDeleteUserSuccess, handleDeleteUserFailure }) => {
    try {
        console.log(`URL >> ${BASE_URL}/user/delete/${id}`);
        const result = await axios.delete(`${BASE_URL}/user/delete/${id}`)
        if (result?.data?.message) {
            return handleDeleteUserSuccess(result?.data?.message)
        }
        console.log('deleteUser ', result);
    } catch (error) {
        console.error('deleteUser ', error);
        handleDeleteUserFailure(error?.response?.data?.error)
    }
}


// for creating city
export const createCity = async ({ body, handleCreateCitySuccess, handleCreateCityFailure }) => {
    try {
        console.log("trying")
        const result = await axios.post(`${BASE_URL}city`, { ...body })
        console.log('createCity ', result);
        if (result?.data?.newCity) {
            return handleCreateCitySuccess(result.data)
        }

    } catch (error) {
        console.error('createCity ', error);
        handleCreateCityFailure(error?.response?.data?.error)
    }
}

//for getting cities
export const fetchLocations = async ({ city, country, setLocations }) => {

    try {
        const params = new URLSearchParams();
        if (city) {
            params.append('city', city)
        }
        if (country) {
            params.append('country', country)
        }

        const query = params.toString();
        const result = await axios.get(`${BASE_URL}/city${query ? `?${query}` : ''}`)
        setLocations(result?.data || [])

    } catch (error) {
        console.error('fetchLocations ', error);
    }
}


// to fetch addresses
export const fetchAddresses = async ({ user_id, address, city, setAddresses }) => {
    try {
        let query = '';
        if (user_id) {
            query += `user_id=${user_id}&`
        }
        if (address) {
            query += `address=${address}&`
        }
        if (city) {
            query += `city=${city}`
        }
        const result = await axios.get(`${BASE_URL}/address?${query}`)
        console.log('fetchAddresses ', result);
        setAddresses(result?.data || [])

    } catch (error) {
        console.error('fetchParkings ', error);
    }
}
